/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="94.27"
        height="95.58"
        viewBox="0 0 94.27 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M32.08 24.41v2.69l-.42.07-.42.09a6.45 6.45 0 0 0-4.85 3.94 7.94 7.94 0 0 0-.56 3.67 6.31 6.31 0 0 0 3.37 5.36A28.22 28.22 0 0 0 32 41.5c1.18.5 2.38 1 3.56 1.46a2.16 2.16 0 0 1 1.35 2.35A2.34 2.34 0 0 1 35 47.65a7.47 7.47 0 0 1-1.49.16A3.71 3.71 0 0 1 29.72 45c-.11-.33-.19-.67-.29-1L25 45.17a9.34 9.34 0 0 0 2.17 4.46 7.59 7.59 0 0 0 4.94 2.27v3.48H35v-3.44c.59-.12 1.16-.21 1.71-.36a6.67 6.67 0 0 0 4.74-3.84A7.9 7.9 0 0 0 42 43a6.21 6.21 0 0 0-3.15-4.47 35.11 35.11 0 0 0-4.31-1.88c-.89-.35-1.75-.76-2.6-1.18a1.91 1.91 0 0 1-1-1.17 2.63 2.63 0 0 1 1.75-3.28h.09a3.08 3.08 0 0 1 3 .78A6.06 6.06 0 0 1 37 33.67c.1.22.19.44.29.68l4-1.67a8.28 8.28 0 0 0-1.49-3A7.12 7.12 0 0 0 35 27.1v-2.69Z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#0e497b"
          d="M65.94 12.37H1.25A1.25 1.25 0 0 0 0 13.62v80.71a1.25 1.25 0 0 0 1.25 1.25h64.69a1.25 1.25 0 0 0 1.25-1.23V13.62A1.25 1.25 0 0 0 66 12.37Zm-1.25 2.5v78.21H2.5V14.87Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M51.92 64.91A1.25 1.25 0 0 1 52 67.4H15.14a1.25 1.25 0 0 1-1.25-1.25A1.27 1.27 0 0 1 15 64.91h36.92ZM51.92 77.12a1.25 1.25 0 0 1 .08 2.49H15.14a1.25 1.25 0 0 1-1.25-1.25A1.27 1.27 0 0 1 15 77.12h36.92ZM28.61 0h.13l64.4 6.2a1.25 1.25 0 0 1 1.13 1.23v.13L86.54 87.9A1.25 1.25 0 0 1 85.3 89h-.13l-19.32-1.83a1.25 1.25 0 1 1 .12-2.5h.12l18.08 1.74 7.49-77.86-61.91-6-1.08 11.2a1.24 1.24 0 0 1-1.23 1.13h-.13a1.25 1.25 0 0 1-1.13-1.24v-.14l1.2-12.38A1.26 1.26 0 0 1 28.61 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="m66.09 56.42 8 .77a1.25 1.25 0 0 1-.09 2.5h-.13l-8-.77a1.25 1.25 0 0 1 .11-2.5ZM66.09 68.69l6.87.66a1.25 1.25 0 0 1-.11 2.49h-.13l-6.87-.66a1.25 1.25 0 1 1 .11-2.5h.13ZM66.09 44.15l9.21.85a1.25 1.25 0 0 1 1.13 1.36 1.24 1.24 0 0 1-1.24 1.1h-.13l-9.21-.89a1.25 1.25 0 0 1 .15-2.42ZM66.08 31.88l10.4 1a1.25 1.25 0 0 1-.12 2.5h-.12l-10.4-1a1.25 1.25 0 1 1 .11-2.5ZM66 19.61h.13l11.56 1.12a1.25 1.25 0 0 1-.12 2.49h-.12l-11.6-1.12a1.25 1.25 0 0 1 .15-2.49Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwoPapersWithDollarSignIcon';

export default Icon;
